import React, { useState, useEffect, useRef, useMemo } from "react";
import config from "../../config/config.json";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "../../utils/HttpRequest";
// import { createAndDownloadBlobFile } from "../../utils/Common";
import Header from "../Header/Header";
import { Toast } from "primereact/toast";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAward,
  faCheckCircle,
  faSpinner,
  faTimesCircle,
  faExclamationTriangle,
  faClipboardCheck,
  faRedo,
  faBookOpen,
  faFilter,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./TrainingRecords.css";

const TrainingRecord = () => {
  const [searchParams] = useSearchParams();
  const urlParams = new URLSearchParams(window.location.search);
  var email = urlParams.get("user");
  var username = urlParams.get("username");
  var lessonid = urlParams.get("lessonid");

  const toast = useRef();
  const navigate = useNavigate();

  const [trainingRecordsData, setTrainingRecordsData] = useState([]);
  const [showCompletionColumn, setShowCompletionColumn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const [changeCounter, setChangeCounter] = useState(0);
  const [showLoadingDialog, setShowLoadingDialog] = useState(false);
  const [completionMessage, setCompletionMessage] = useState(
    "Please wait while lesson is marked as Completed"
  );

  const [showNotificationDialog, setShowNotificationDialog] = useState(false);
  const [notificationData, setNotificationData] = useState(null);

  const [showSurveyDialog, setShowSurveyDialog] = useState(false);
  const [lessonDetailsMain, setLessonDetailsMain] = useState(null);
  const [surveyLessonData, setSurveyLessonData] = useState(null);
  const [currentQuestionCounter, setCurrentQuestionCounter] = useState(0);
  const [submittingAnswer, setSubmittingAnswer] = useState(false);
  const [userAnswer, setUserAnswer] = useState(null);
  const [isSurveyCompleted, setIsSurveyCompleted] = useState(false);

  const [companyScore, setCompanyScore] = useState(false);
  const [companyPassScore, setCompanyPassScore] = useState("");

  // Filter & search state
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("priority");

  // Config fetchers
  const getShowCompanyScore = async () => {
    try {
      const url = config.api.url + "getTrialConfig/showAssessmentScore";
      get(url).then((response) => {
        setCompanyScore(response.data.value);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getCompanyPassScore = async () => {
    try {
      const url = config.api.url + "getTrialConfig/companyPassScore";
      get(url).then((response) => {
        setCompanyPassScore(response.data.value);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getShowCompanyScore();
    getCompanyPassScore();
  }, []);

  useEffect(() => {
    setPageLoading(true);
    let url = config.api.url + "getLessonsCompletionDetailsForMe";
    if (email != null && username != null) {
      url =
        config.api.url +
        "getLessonsCompletionDetailsOneUser/" +
        email.replace(/ /g, "+");
    }
    get(url)
      .then((result) => {
        let trainingRecords = result.data;
        setTrainingRecordsData(trainingRecords);
        if (
          email == undefined ||
          email == null ||
          (localStorage.getItem("userRole") !== "smiadmin" &&
            localStorage.getItem("userRole") !== "monitor" &&
            localStorage.getItem("userRole") !== "cro" &&
            localStorage.getItem("userRole") !== "sponsor" &&
            localStorage.getItem("userRole") !== "admin")
        ) {
          setShowCompletionColumn(false);
        } else {
          setShowCompletionColumn(true);
        }
        setPageLoading(false);
      })
      .catch((err) => {
        console.log("Error occured fetching training records", err);
        setPageLoading(false);
      });

    get(config.api.url + "getNotification?location=trainingrecord")
      .then((result) => {
        let notificationData = result.data;
        if (notificationData.group) {
          setShowNotificationDialog(true);
          setNotificationData({
            msg: notificationData.message,
            title: notificationData.title,
            notifID: notificationData.group,
          });
        }
      })
      .catch((err) => {
        console.log("Error occured fetching notification data", err);
      });

    // survey related processing
    let surveyUrl = config.api.url + "getTrialConfig/showSurvey";
    get(surveyUrl)
      .then((result) => {
        let showSurvey = result.data;
        if (lessonid != null && lessonid !== "" && showSurvey.value) {
          let showSurveyLessonID = "";
          get(config.api.url + "getTrialConfig/showSurveyLessonID")
            .then((result) => {
              showSurveyLessonID = result.data.value;
              if (!showSurveyLessonID && showSurveyLessonID === "") {
                get(config.api.url + "getLessons").then((result) => {
                  let alllessonds = result.data;
                  let activeSurveyLessons = [];
                  for (let lesson of alllessonds) {
                    if (
                      lesson.status === "active" &&
                      lesson.lessontype === "survey"
                    ) {
                      activeSurveyLessons.push(lesson.lessonid);
                    }
                  }
                  if (activeSurveyLessons.length > 0) {
                    showSurveyLessonID = activeSurveyLessons[0];
                    post(config.api.url + "updateTrialConfig", {
                      name: "showSurveyLessonID",
                      value: showSurveyLessonID,
                    });
                  }
                });
              }
              if (
                showSurveyLessonID &&
                showSurveyLessonID.value &&
                showSurveyLessonID.value !== ""
              ) {
                showSurveyLessonID = showSurveyLessonID.value;
              }
              setShowSurveyDialog(true);
              get(config.api.url + "getLessonDetails/" + lessonid)
                .then((result) => {
                  setLessonDetailsMain(result.data);
                  get(
                    config.api.url + "getLessonandTopics/" + showSurveyLessonID
                  )
                    .then((result) => {
                      setSurveyLessonData(result.data);
                    })
                    .catch((err) => {
                      console.log("Error getting survey lesson details", err);
                    });
                })
                .catch((err) => {
                  console.log("Error getting lesson details ", err);
                });
            })
            .catch((err) => {
              console.log("Error fetching showSurveyLessonID", err);
            });
        }
      })
      .catch((err) => {
        console.log("Error getting the survey URL", err);
      });
  }, [searchParams, changeCounter]);

  // Utility functions
  function createAndDownloadBlobFile(body, filename, extension = "txt") {
    const blob = new Blob([body]);
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement("a");
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const handleDownloadCertificate = (lessonid) => {
    setLoading(true);
    var url = config.api.url + "createCertificate";
    let data = { lessonid: lessonid };
    const urlParams = new URLSearchParams(window.location.search);
    var userEmail = urlParams.get("user");
    if (userEmail != null) {
      userEmail = userEmail.replace(/ /g, "+");
    }
    if (
      ["smiadmin","monitor", "cro", "sponsor"].includes(localStorage.getItem("userRole")) &&
      userEmail !== null &&
      userEmail.length > 6
    ) {
      data = { lessonid: lessonid, email: userEmail };
    }
    post(url, data)
      .then((result) => {
        let certificateData = result.data;
        let fileName =
          "certificate_" +
          certificateData
            .substring(certificateData.lastIndexOf("/") + 1)
            .split(".")[0];
        const s3FetchInstance = axios.create();
        s3FetchInstance
          .get(certificateData, { responseType: "blob" })
          .then((result) => {
            createAndDownloadBlobFile(result.data, fileName, "pdf");
          })
          .catch((err) => {
            console.log("Error fetching certificate file from s3", err);
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log("Error fetching certificate ", err);
        setLoading(false);
      });
  };

  const handleLessonMarking = (lessonid, marking) => {
    setShowLoadingDialog(true);
    let data = JSON.stringify({ lessonid: lessonid });
    const urlParams = new URLSearchParams(window.location.search);
    var userEmail = urlParams.get("user");
    if (userEmail != null) {
      userEmail = userEmail.replace(/ /g, "+");
    }
    if (
      (localStorage.getItem("userRole") === "smiadmin" ||
        localStorage.getItem("userRole") === "monitor" ||
        localStorage.getItem("userRole") === "cro" ||
        localStorage.getItem("userRole") === "sponsor" ||
        localStorage.getItem("userRole") === "admin") &&
      userEmail !== null &&
      userEmail.length > 6
    ) {
      data = { lessonid: lessonid, email: userEmail };
    }
    var url = config.api.url + "markLessonCompleteForUser";
    if (marking === "incomplete") {
      url = url + "?mark=incomplete";
      setCompletionMessage("Please wait while lesson is marked as Incompleted");
    } else {
      setCompletionMessage("Please wait while lesson is marked as Completed");
    }
    post(url, data)
      .then(() => {
        // window.location.reload();
        setChangeCounter(changeCounter + 1);
        if (marking === "incomplete") {
          setCompletionMessage("Lesson marked as incomplete");
        } else {
          setCompletionMessage("Lesson marked as complete");
        }
        setShowLoadingDialog(false);
      })
      .catch((err) => {
        console.log("Error calling markLessonCompletionForUser API ", err);
      });
  };

  const handleAnswerSubmit = () => {
    setSubmittingAnswer(true);
    // calling API here
    // {
    //     "answerbyuser": "Yes",
    //     "lessonid": "S-019",
    //     "survey_for_lesson_id": "RL-010",
    //     "testid": "S-019-s01-01",
    //     "assessmentid": "S-019-s01-01",
    //     "username": "neha+smiadmin@hatchery.com",
    //     "questionid": "1698101489201Did you enjoy the lesson?"
    // }
    let obj = {};
    let currentTopicData = surveyLessonData.topics[currentQuestionCounter];
    obj["answerbyuser"] = userAnswer;
    obj["lessonid"] = currentTopicData.lessonid;
    obj["survey_for_lesson_id"] = lessonid;
    obj["testid"] = currentTopicData.testid;
    obj["assessmentid"] = currentTopicData.testid;
    obj["username"] = localStorage.getItem("email");
    obj["questionid"] = currentTopicData.questionid;
    post(config.api.url + "insertAnswerData", obj)
      .then(() => {
        setSubmittingAnswer(false);
        setUserAnswer(null);
        if (currentQuestionCounter + 1 >= surveyLessonData.topics.length) {
          setIsSurveyCompleted(true);
          setTimeout(() => {
            setShowSurveyDialog(false);
            setCurrentQuestionCounter(0);
            setIsSurveyCompleted(false);
          }, 2000);
        } else {
          setCurrentQuestionCounter(currentQuestionCounter + 1);
        }
      })
      .catch((err) => {
        console.log("Error submitting survey answer", err);
      });
  };

  const dismissNotification = () => {
    post(config.api.url + "dismissNotification", {
      notificationID: notificationData.notifID,
    }).catch((err) => {
      console.log("Error dismissing notification ", err);
    });
  };

  // Computed data
  const stats = useMemo(() => {
    const required = trainingRecordsData.filter(
      (r) => r.lessonRequired === "required"
    );
    const requiredCompleted = required.filter(
      (r) => r.status === "completed"
    );
    const incomplete = trainingRecordsData.filter(
      (r) => r.status !== "completed"
    );
    const failed = trainingRecordsData.filter(
      (r) => r.status === "completed" && r.result === "Fail"
    );
    const completedPass = trainingRecordsData.filter(
      (r) => r.status === "completed" && r.result !== "Fail"
    );

    const progressPct =
      required.length > 0
        ? Math.round((requiredCompleted.length / required.length) * 100)
        : 100;

    return {
      total: trainingRecordsData.length,
      incomplete: incomplete.length,
      failed: failed.length,
      completedPass: completedPass.length,
      requiredTotal: required.length,
      requiredCompleted: requiredCompleted.length,
      progressPct,
    };
  }, [trainingRecordsData]);

  // Filtered and sorted data
  const filteredData = useMemo(() => {
    let data = [...trainingRecordsData];

    // Apply search
    if (searchText.trim()) {
      const term = searchText.toLowerCase();
      data = data.filter((r) => r.name.toLowerCase().includes(term));
    }

    // Apply filter
    switch (activeFilter) {
      case "action":
        data = data.filter(
          (r) =>
            r.status === "incomplete" ||
            (r.status === "completed" && r.result === "Fail")
        );
        break;
      case "completed":
        data = data.filter(
          (r) => r.status === "completed" && r.result !== "Fail"
        );
        break;
      case "required":
        data = data.filter((r) => r.lessonRequired === "required");
        break;
      case "optional":
        data = data.filter((r) => r.lessonRequired === "optional");
        break;
      default:
        break;
    }

    // Apply sort
    switch (sortBy) {
      case "priority":
        data.sort((a, b) => {
          const getPriority = (r) => {
            if (r.lessonRequired === "required" && r.status === "incomplete")
              return 0;
            if (r.status === "completed" && r.result === "Fail") return 1;
            if (r.lessonRequired === "optional" && r.status === "incomplete")
              return 2;
            if (r.status === "completed" && r.result !== "Fail") return 3;
            return 4;
          };
          return getPriority(a) - getPriority(b);
        });
        break;
      case "name":
        data.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "status":
        data.sort((a, b) => a.status.localeCompare(b.status));
        break;
      default:
        break;
    }

    return data;
  }, [trainingRecordsData, activeFilter, searchText, sortBy]);

  // Group data into sections
  const sections = useMemo(() => {
    const actionRequired = filteredData.filter(
      (r) =>
        (r.lessonRequired === "required" && r.status === "incomplete") ||
        (r.status === "completed" && r.result === "Fail")
    );
    const completedItems = filteredData.filter(
      (r) => r.status === "completed" && r.result !== "Fail"
    );
    const optionalIncomplete = filteredData.filter(
      (r) => r.lessonRequired === "optional" && r.status === "incomplete"
    );

    return { actionRequired, completedItems, optionalIncomplete };
  }, [filteredData]);

  // Helper: get card class
  const getCardClass = (record) => {
    if (record.status === "incomplete" && record.lessonRequired === "required")
      return "required-incomplete";
    if (record.status === "completed" && record.result === "Fail")
      return "completed-fail";
    if (record.status === "completed" && record.result !== "Fail")
      return "completed-pass";
    return "optional-incomplete";
  };

  // Helper: get status icon
  const getStatusIcon = (record) => {
    if (record.status === "incomplete")
      return { icon: faExclamationTriangle, cls: "pending" };
    if (record.result === "Fail") return { icon: faTimesCircle, cls: "fail" };
    if (record.result === "Pass" || record.result === "NA")
      return { icon: faCheckCircle, cls: "pass" };
    return { icon: faCheckCircle, cls: "pass" };
  };

  // Helper: get status text
  const getStatusText = (record) => {
    if (record.status === "incomplete") return "Incomplete";
    if (record.lessontype === "assessment") {
      return record.result === "Pass" ? "Pass" : "Fail";
    }
    return "Completed";
  };

  // Progress Ring SVG
  const ProgressRing = ({ percentage }) => {
    const radius = 50;
    const stroke = 8;
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset =
      circumference - (percentage / 100) * circumference;

    return (
      <div className="tr-progress-ring">
        <svg height={radius * 2} width={radius * 2}>
          <circle
            stroke="#e9ecef"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#107639"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference + " " + circumference}
            style={{ strokeDashoffset, transition: "stroke-dashoffset 0.5s ease" }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <div className="tr-progress-ring-text">
          <span className="percentage">{percentage}%</span>
          <span className="label">Complete</span>
        </div>
      </div>
    );
  };

  // Render a lesson card
  const renderLessonCard = (record) => {
    const statusInfo = getStatusIcon(record);
    const statusText = getStatusText(record);
    const cardClass = getCardClass(record);
    const showRetake =
      record.status === "completed" &&
      record.result === "Fail" &&
      record.lessontype === "assessment";
    const showCertificate =
      record.status === "completed" && record.result === "Pass";
    const showTakeLesson = record.status === "incomplete";

    return (
      <div
        className={`tr-lesson-card ${cardClass}`}
        key={record.id}
        onClick={() => {
          if (window.innerWidth <= 768) {
            navigate(
              record.lessontype === "assessment"
                ? `/lessonviewassessmentmobile?lessonid=${record.id}`
                : `/lessonviewmobile?lessonid=${record.id}`
            );
          } else {
            navigate(`/lessonview?lessonid=${record.id}`);
          }
        }}
      >
        <div className={`tr-lesson-status-icon ${statusInfo.cls}`}>
          <FontAwesomeIcon icon={statusInfo.icon} />
        </div>

        <div className="tr-lesson-info">
          <h6 title={record.name}>
            {record.name}
            {record.status === "completed" && (
              <span className="tr-language-tag">
                {" · "}
                <FontAwesomeIcon icon={faLanguage} /> {record.language || "English"}
              </span>
            )}
          </h6>
          <div className="tr-lesson-meta">
            <span
              className={`tr-lesson-badge ${record.lessonRequired === "required" ? "required" : "optional"}`}
            >
              {record.lessonRequired === "required" ? "Required" : "Optional"}
            </span>
            {record.lessontype === "assessment" && (
              <span className="tr-lesson-badge assessment">Assessment</span>
            )}
            <span
              className={`tr-lesson-badge ${record.result === "Fail" ? "fail-badge" : record.status === "completed" ? "pass-badge" : ""}`}
            >
              {statusText}
            </span>
          </div>
        </div>

        {companyScore &&
          record.percentage != null &&
          record.lessontype === "assessment" && (
            <div
              className={`tr-lesson-score ${record.result === "Pass" ? "pass" : "fail"}`}
            >
              {Math.round(record.percentage)}%
            </div>
          )}

        <div className="tr-lesson-actions">
          {showTakeLesson && (
            <button
              className="tr-action-btn take"
              onClick={(e) => {
                e.stopPropagation();
                if (window.innerWidth <= 768) {
                  navigate(
                    record.lessontype === "assessment"
                      ? `/lessonviewassessmentmobile?lessonid=${record.id}`
                      : `/lessonviewmobile?lessonid=${record.id}`
                  );
                } else {
                  navigate(`/lessonview?lessonid=${record.id}`);
                }
              }}
            >
              <FontAwesomeIcon icon={faBookOpen} /> Start
            </button>
          )}
          {showRetake && (
            <button
              className="tr-action-btn retake"
              onClick={(e) => {
                e.stopPropagation();
                if (window.innerWidth <= 768) {
                  navigate(
                    `/lessonviewassessmentmobile?lessonid=${record.id}`
                  );
                } else {
                  navigate(`/lessonview?lessonid=${record.id}`);
                }
              }}
            >
              <FontAwesomeIcon icon={faRedo} /> Retake
            </button>
          )}
          {showCertificate && (
            <button
              className="tr-action-btn certificate"
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadCertificate(record.id);
              }}
            >
              <FontAwesomeIcon icon={faAward} /> Certificate
            </button>
          )}
          {showCompletionColumn && (
            <>
              {record.status === "completed" ? (
                record.result === "Pass" ? (
                  <button
                    className="tr-action-btn mark"
                    title="Mark as Incomplete"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLessonMarking(record.id, "incomplete");
                    }}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} />
                  </button>
                ) : record.lessontype !== "assessment" ? (
                  <button
                    className="tr-action-btn mark"
                    title="Mark as Complete"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLessonMarking(record.id, "");
                    }}
                  >
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </button>
                ) : null
              ) : record.lessontype !== "assessment" ? (
                <button
                  className="tr-action-btn mark"
                  title="Mark as Complete"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLessonMarking(record.id, "");
                  }}
                >
                  <FontAwesomeIcon icon={faCheckCircle} />
                </button>
              ) : null}
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="tr-page app">
      {/* Full-page loading overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            zIndex: "999",
            backgroundColor: "rgba(0,0,0,0.5)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
                                      }}
        >
          <FontAwesomeIcon
            style={{ fontSize: "30px" }}
            className="c-smi-green"
            icon={faSpinner}
            spin
          />
        </div>
      )}

      <Header />
      <Toast ref={toast} />

      <div className="page-inner" style={{ padding: "1.5rem" }}>
        {/* Page Title */}
        <div style={{ marginBottom: "1.5rem" }}>
          <h4 style={{ margin: 0, fontWeight: 700, color: "#333" }}>
            Training Records
            {username ? ` — ${username}` : ""}
          </h4>
          {companyScore && companyPassScore && (
            <p style={{ margin: "0.25rem 0 0", fontSize: "0.85rem", color: "#6c757d" }}>
              Company passing score for assessments: {companyPassScore}%
            </p>
          )}
        </div>

        {pageLoading ? (
          <div>
            {/* Skeleton Summary Cards */}
            <div className="tr-summary">
              {Array.from({ length: 4 }).map((_, i) => (
                <div className="tr-summary-card" key={i}>
                  <div className="tr-summary-icon total" style={{ background: "#e9ecef" }}></div>
                  <div className="tr-summary-info">
                    <div className="skeleton-line" style={{ width: "40px", height: "24px", marginBottom: "6px" }}></div>
                    <div className="skeleton-line" style={{ width: "80px", height: "12px" }}></div>
                  </div>
                </div>
              ))}
            </div>

            {/* Skeleton Progress Section */}
            <div className="tr-progress-section">
              <div className="skeleton-circle" style={{ width: "100px", height: "100px", borderRadius: "50%" }}></div>
              <div className="tr-progress-details">
                <div className="skeleton-line" style={{ width: "200px", height: "16px", marginBottom: "8px" }}></div>
                <div className="skeleton-line" style={{ width: "280px", height: "12px" }}></div>
              </div>
            </div>

            {/* Skeleton Toolbar */}
            <div className="tr-toolbar" style={{ marginBottom: "1rem" }}>
              <div className="tr-toolbar-left">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div className="skeleton-line" key={i} style={{ width: "80px", height: "32px", borderRadius: "20px" }}></div>
                ))}
              </div>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <div className="skeleton-line" style={{ width: "180px", height: "32px", borderRadius: "20px" }}></div>
                <div className="skeleton-line" style={{ width: "120px", height: "32px", borderRadius: "20px" }}></div>
              </div>
            </div>

            {/* Skeleton Lesson Cards */}
            <div className="tr-section">
              <div className="tr-section-header">
                <div className="skeleton-line" style={{ width: "120px", height: "14px" }}></div>
              </div>
              <div className="tr-lesson-list">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div className="tr-lesson-card" key={i} style={{ borderLeftColor: "#e9ecef" }}>
                    <div className="skeleton-circle" style={{ width: "40px", height: "40px", borderRadius: "50%", flexShrink: 0 }}></div>
                    <div className="tr-lesson-info" style={{ flex: 1 }}>
                      <div className="skeleton-line" style={{ width: `${60 + Math.random() * 30}%`, height: "14px", marginBottom: "8px" }}></div>
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <div className="skeleton-line" style={{ width: "60px", height: "18px", borderRadius: "10px" }}></div>
                        <div className="skeleton-line" style={{ width: "50px", height: "18px", borderRadius: "10px" }}></div>
                      </div>
                    </div>
                    <div className="skeleton-line" style={{ width: "70px", height: "28px", borderRadius: "6px" }}></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Summary Cards */}
            <div className="tr-summary">
              <div className="tr-summary-card">
                <div className="tr-summary-icon action">
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div className="tr-summary-info">
                  <h3>{stats.incomplete + stats.failed}</h3>
                  <p>Action Required</p>
                </div>
              </div>
              <div className="tr-summary-card">
                <div className="tr-summary-icon completed">
                  <FontAwesomeIcon icon={faCheckCircle} />
                </div>
                <div className="tr-summary-info">
                  <h3>{stats.completedPass}</h3>
                  <p>Completed</p>
                </div>
              </div>
              <div className="tr-summary-card">
                <div className="tr-summary-icon failed">
                  <FontAwesomeIcon icon={faTimesCircle} />
                </div>
                <div className="tr-summary-info">
                  <h3>{stats.failed}</h3>
                  <p>Failed (Retake)</p>
                </div>
              </div>
              <div className="tr-summary-card">
                <div className="tr-summary-icon total">
                  <FontAwesomeIcon icon={faClipboardCheck} />
                </div>
                <div className="tr-summary-info">
                  <h3>{stats.total}</h3>
                  <p>Total Trainings</p>
                </div>
              </div>
            </div>

            {/* Progress Section */}
            <div className="tr-progress-section">
              <ProgressRing percentage={stats.progressPct} />
              <div className="tr-progress-details">
                <h5>Required Curriculum Progress</h5>
                <p>
                  {stats.requiredCompleted} of {stats.requiredTotal} required
                  trainings completed
                  {stats.requiredTotal === 0 &&
                    " — You have no required assignments"}
                </p>
              </div>
            </div>

            {/* Toolbar: Filters + Search + Sort */}
            <div className="tr-toolbar">
              <div className="tr-toolbar-left">
                <button
                  className={`tr-filter-btn ${activeFilter === "all" ? "active" : ""}`}
                  onClick={() => setActiveFilter("all")}
                >
                  All
                </button>
                <button
                  className={`tr-filter-btn ${activeFilter === "action" ? "active" : ""}`}
                  onClick={() => setActiveFilter("action")}
                >
                  <FontAwesomeIcon icon={faFilter} style={{ marginRight: 4 }} />
                  Action Required
                </button>
                <button
                  className={`tr-filter-btn ${activeFilter === "completed" ? "active" : ""}`}
                  onClick={() => setActiveFilter("completed")}
                >
                  Completed
                </button>
                <button
                  className={`tr-filter-btn ${activeFilter === "required" ? "active" : ""}`}
                  onClick={() => setActiveFilter("required")}
                >
                  Required
                </button>
                <button
                  className={`tr-filter-btn ${activeFilter === "optional" ? "active" : ""}`}
                  onClick={() => setActiveFilter("optional")}
                >
                  Optional
                </button>
              </div>
              <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                <input
                  type="text"
                  className="tr-search-input"
                  placeholder="Search trainings..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <select
                  className="tr-sort-select"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="priority">Sort: Priority</option>
                  <option value="name">Sort: Name</option>
                  <option value="status">Sort: Status</option>
                </select>
              </div>
            </div>

            {/* Content Sections */}
            {filteredData.length === 0 ? (
              <div className="tr-empty">
                <FontAwesomeIcon icon={faClipboardCheck} />
                <p>No trainings match your filter criteria.</p>
              </div>
            ) : activeFilter === "all" ? (
              <>
                {/* Action Required Section */}
                {sections.actionRequired.length > 0 && (
                  <div className="tr-section">
                    <div className="tr-section-header">
                      <h6>Action Required</h6>
                      <span className="badge" style={{ background: "#fff3cd", color: "#856404" }}>
                        {sections.actionRequired.length}
                      </span>
                    </div>
                    <div className="tr-lesson-list">
                      {sections.actionRequired.map(renderLessonCard)}
                    </div>
                  </div>
                )}

                {/* Optional Incomplete */}
                {sections.optionalIncomplete.length > 0 && (
                  <div className="tr-section">
                    <div className="tr-section-header">
                      <h6>Not Yet Completed</h6>
                      <span className="badge" style={{ background: "#e9ecef", color: "#6c757d" }}>
                        {sections.optionalIncomplete.length}
                      </span>
                    </div>
                    <div className="tr-lesson-list">
                      {sections.optionalIncomplete.map(renderLessonCard)}
                    </div>
                  </div>
                )}

                {/* Completed Section */}
                {sections.completedItems.length > 0 && (
                  <div className="tr-section">
                    <div className="tr-section-header">
                      <h6>Completed</h6>
                      <span className="badge" style={{ background: "#d4edda", color: "#155724" }}>
                        {sections.completedItems.length}
                      </span>
                    </div>
                    <div className="tr-lesson-list">
                      {sections.completedItems.map(renderLessonCard)}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="tr-section">
                <div className="tr-lesson-list">
                  {filteredData.map(renderLessonCard)}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div>
        <Modal
          show={showLoadingDialog}
          onHide={() => setShowLoadingDialog(false)}
        >
          <Card.Body
            style={{ height: "200px" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Row>
              <Col lg={12}>
                <div className="text-center">
                  <h6 className="card-title">{completionMessage}</h6>
                  <div className="mb-3">
                    {completionMessage.includes("Please wait") ? (
                      <i
                        className="pi pi-spin pi-spinner"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    ) : (
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "3rem", color: "green" }}
                      ></i>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Modal>
      </div>
      <div>
        <Modal
          show={showSurveyDialog}
          onHide={() => setShowSurveyDialog(false)}
        >
          <Modal.Header className="w-100">
            <Modal.Title className="w-100">
              {surveyLessonData &&
                (!isSurveyCompleted ? (
                  <h6 className="modal-title w-100">
                    Please complete this survey for the lesson{" "}
                    {lessonDetailsMain?.lessonname}
                    <span
                      className="float-right"
                      onClick={() => {
                        setShowSurveyDialog(false);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        style={{ fontSize: "1.25rem" }}
                      />
                    </span>
                  </h6>
                ) : (
                  <h5 id="SurveyPopupSuccessTitle" className="modal-title">
                    Thank you for completing this survey.
                  </h5>
                ))}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card.Body
              style={{ height: "auto", padding: "20px 10px" }}
              className={isSurveyCompleted ? "d-none" : ""}
            >
              <Row>
                <Col lg={12}>
                  {surveyLessonData ? (
                    <div className="">
                      <span>
                        Question {currentQuestionCounter + 1} of{" "}
                        {surveyLessonData?.topics?.length}
                      </span>
                      <div className="text-left mt-2 pt-2 ml-5 pr-5 embed-responsive-item d-block w-100">
                        <h6
                          id="assessmentDataQuestion"
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html:
                              surveyLessonData?.topics[currentQuestionCounter]
                                ?.question,
                          }}
                        />

                        {surveyLessonData?.topics[currentQuestionCounter]
                          ?.questiontype !== undefined &&
                        surveyLessonData?.topics[currentQuestionCounter]
                          ?.questiontype === "text" ? (
                          <div id="SurveyTextAnswer">
                            <textarea
                              className="form-control"
                              onChange={(e) => {
                                setUserAnswer(e.target.value);
                              }}
                              name="answerbyuser"
                              id="surveyTextAnswer"
                              rows="3"
                              cols="50"
                            ></textarea>
                          </div>
                        ) : (
                          Array.from({ length: 10 }).map((value, index) => (
                            <div
                              key={`answer` + index}
                              className={`custom-control custom-radio mt-4 ${
                                surveyLessonData?.topics[
                                  currentQuestionCounter
                                ]["answer" + (index + 1)] !== ""
                                  ? ""
                                  : "d-none"
                              }`}
                              id={`divAssessmentDataAnswer${index + 1}`}
                            >
                              <input
                                className="custom-control-input"
                                id={`a${index + 1}`}
                                onClick={() => {
                                  setUserAnswer(
                                    surveyLessonData?.topics[
                                      currentQuestionCounter
                                    ]["answer" + (index + 1)]
                                  );
                                }}
                                type="radio"
                                name="answerbyuser"
                                value={
                                  surveyLessonData?.topics.length &&
                                  surveyLessonData?.topics[
                                    currentQuestionCounter
                                  ]["answer" + (index + 1)]
                                }
                                required=""
                              />
                              <label
                                id={`assessmentDataAnswer${index + 1}`}
                                className="custom-control-label"
                                htmlFor={`a${index + 1}`}
                              >
                                {surveyLessonData?.topics.length &&
                                  surveyLessonData?.topics[
                                    currentQuestionCounter
                                  ]["answer" + (index + 1)]}
                              </label>
                            </div>
                          ))
                        )}
                        <button
                          id="submitAnswerSurveyPopup"
                          disabled={userAnswer === null || submittingAnswer}
                          className="btn btn-success mt-4"
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAnswerSubmit();
                          }}
                        >
                          Save Answer
                          {submittingAnswer && (
                            <>
                              &nbsp;
                              <i
                                className="loader pi pi-spinner pi-spin"
                                aria-hidden="true"
                              ></i>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div id="SurveyPopupLoaderBlock">
                      <div className="row">
                        <div className="col pb-5 pt-5 m-5 pr-0 d-flex justify-content-center">
                          <div
                            className="spinner-border"
                            style={{
                              width: "3rem",
                              height: "3rem",
                              color: "green !important",
                            }}
                            role="status"
                          ></div>
                          <h6
                            className="card-title"
                            id="SurveyPopupLoaderBlockMessage"
                          >
                            {" "}
                            Please wait loading Question.
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Modal.Body>
        </Modal>
      </div>
      <div>
        <Modal
          show={showNotificationDialog}
          onHide={() => setShowNotificationDialog(false)}
        >
          <Modal.Header>
            <Modal.Title>
              <h5 id="notificationModalLabel" className="modal-title">
                {notificationData?.title}
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span
              id="notificationText"
              dangerouslySetInnerHTML={{
                __html: notificationData?.msg ? notificationData.msg : "",
              }}
            ></span>
          </Modal.Body>
          <Modal.Footer className="float-right">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                setShowNotificationDialog(false);
              }}
            >
              Close
            </button>
            <button
              id="displayNotificationModalDismiss"
              type="button"
              onClick={() => {
                setShowNotificationDialog(false);
                dismissNotification();
              }}
              className="btn btn-light"
            >
              Dismiss
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default TrainingRecord;
